import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    pruebaOjos: [],
  },

  getters: {
    getPruebaOjos: (state) => state.pruebaOjos,
  },

  mutations: {
    SET_PRUEBA_OJOS(state, pruebaOjos) {
      state.pruebaOjos = pruebaOjos;
    },
  },

  actions: {
    async fetchPruebaOjos({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catPruebaOjos')
        .then((response) => {
          commit('SET_PRUEBA_OJOS', response.data.data);
        });
    },
  },
};
